


















import Vue from 'vue';
import Component from 'vue-class-component';

const Setup = Vue.extend({
	name: 'FormPasswordInput',
	inheritAttrs: false,
	props: {
		inputClass: {
			default: 'np-input',
		},
		visible: Boolean,
	},
});

@Component
export default class FormPasswordInput extends Setup {
	public inputClass!: any;
	public visible!: boolean;

	public isVisible = this.visible;

	public get input(): HTMLInputElement | null {
		return this.$el.querySelector('input');
	}

	public get passwordIcon(): any {
		return this.isVisible ? ['fal', 'eye'] : ['fal', 'eye-slash'];
	}

	public get iconTitle(): any {
		return this.isVisible ? 'Hide Password' : 'Show Password';
	}

	public get type(): string {
		return this.isVisible ? 'text' : 'password';
	}

	public toggleVisible() {
		this.isVisible = !this.isVisible;

		if (this.input) {
			this.input.setAttribute('type', this.type);
		}
	}
}
